'use client'

import { useEffect } from 'react'
import { useDeviceInfo } from 'src/hooks/useDeviceInfo'

export function DeviceClassManager() {
  const { isMobile, isTablet, isTouch } = useDeviceInfo()

  useEffect(() => {
    document.body.classList.toggle('is-mobile', isMobile)
    document.body.classList.toggle('is-tablet', isTablet)
    document.body.classList.toggle('is-touch', isTouch)
  }, [isMobile, isTablet, isTouch])

  return null
}
